- const { parent, fixture, columns, class: contextClass } = properties

if parent.id && fixture
  table.fixture(class=contextClass)
    thead
      th
        each column in columns
          td: span= parent.columnize(column)
    tbody
      if parent.api === 'gamescorekeeper'
        tr
          - var { scheduledStartTime, startTime, endTime, winnerId, status } = fixture
          - status = status?.toLowerCase()
          - const winner = fixture.participants.find(p => +p.id === +winnerId)
          td: span= fixture.id
          if columns.includes('feed')
            td.live-feed(class={ disabled: ['cancelled', 'forfeited'].includes(status) })
              ft-button(href=parent.linkTo({ tab: 'liveFeed', id: fixture.id }))
                span Feed
          td
            if winnerId
              span= `${winnerId} - ${winner?.name}`
            else
              span -
          td.status(class=status)
            span= status
          td
            span= `${fixture.format.name} ${fixture.format.value}`
            span= `Tieable?: ${fixture.format.isMapTieable}`
          td
            span= `ID: ${fixture.competition.id}`
            span= `Name: ${fixture.competition.name}`
          td
            if scheduledStartTime
              span= parent.moment(scheduledStartTime).format(parent.timestampFormat)
          td
            if startTime
              span= parent.moment(startTime).format(parent.timestampFormat)
          td
            if endTime
              span= parent.moment(endTime).format(parent.timestampFormat)
          td: span= fixture.sport.alias
          td
            each participant in fixture.participants || []
              section
                span= participant.name
                span= `Score: ${participant.score}`
          td
            each map in fixture.maps || []
              - const scores = map.roundScores || []
              - const home = fixture.participants.find(p => +p.id === +scores[0]?.id)
              - const away = fixture.participants.find(p => +p.id === +scores[1]?.id)
              - const mapWinner = fixture.participants.find(p => +p.id === +map.winnerId)
              if scores.length
                section
                  span= map.mapName
                  span= `${scores[0]?.roundsWon} - ${home.name}`
                  span= `${scores[1]?.roundsWon} - ${away.name}`
